import { createFileRoute } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';
import { WebsiteTemplateRegistryPage } from 'src/modules/websites/components/pages/website-template-registry.page';

export const Route = createFileRoute('/settings/website-template-registry')({
  component: WebsiteTemplateRegistryPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
